/* eslint-disable react-hooks/rules-of-hooks */
import { Card, Select, Tabs, Tooltip } from 'antd'
import styled from 'styled-components'
import { IconFont } from '@/components'
import { useEffect, useMemo, useState, useRef } from 'react'
import ReactECharts from 'echarts-for-react'
import SendEmail from '@/assets/imges/send-email.png'
import SubmitEmail from '@/assets/imges/submit-email.png'
import ClickEmail from '@/assets/imges/click-email.png'
import LookEmail from '@/assets/imges/look-email.png'
import SeeThrough from '@/assets/imges/see-through.png'
import { useSearchParams } from 'react-router-dom'
import { useGetDeptAware, useGetDeptRate, useGetTaskChartData, useGetTaskTrend } from './utils'
import { Consciousness } from './consciousness'
import { HitRateChart } from './hit-rate-chart'
import { useSelections } from 'ahooks'
import { GetTaskTrend } from '@/api/fishing-task-detail'
import OverviewLine from '@/assets/imges/phishing/create/overview_line2.png'

const { TabPane } = Tabs
const { Option } = Select
// 指定图表的配置项和数据 折线图
interface GetOptionsProps {
  time: string[]
  send: number[]
  see: number[]
  open: number[]
  click: number[]
  sub: number[]
  through: number[]
  barSend: number[]
  barSee: number[]
  barOpen: number[]
  barClick: number[]
  barSub: number[]
  barThrough: number[]
  trap: number[]
  type: '恶意附件' | '钓鱼链接'
  option: string
  sum: number[]
}

export const TaskAbstract = props => {
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const { taskStd, getTaskBasic, setTaskStdProps, getTaskStd, taskStdProps } = props
  const option1 = (values: { value: number; title: string }) => {
    const { value, title } = values
    return {
      series: [
        {
          type: 'gauge',
          min: 0,
          max: 100,
          startAngle: 180,
          endAngle: 0,
          splitNumber: 5,
          radius: '100%',
          axisLine: {
            lineStyle: {
              width: 10,
              color: [
                [0.39, '#FF5151'],
                [0.59, '#FFB035'],
                [0.79, '#739DFF'],
                [1, '#7FB663'],
              ],
            },
          },
          pointer: {
            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
            length: '15%',
            width: 10,
            offsetCenter: [0, -45],
            itemStyle: {
              color: 'auto',
            },
          },
          axisTick: {
            length: 5,
            lineStyle: {
              color: 'auto',
              width: 1,
            },
            distance: 3,
          },
          splitLine: {
            length: 7,
            distance: 2,
            lineStyle: {
              color: 'auto',
              width: 2,
            },
          },
          axisLabel: {
            color: '#666666',
            fontSize: 8,
            distance: 15,
          },
          title: {
            offsetCenter: [0, -20],
            fontSize: 16,
          },
          detail: {
            fontSize: 20,
            offsetCenter: [0, 10],
            valueAnimation: true,
            formatter: function (num) {
              return `${Math.round(num)}`
            },
            color: 'auto',
          },
          data: [
            {
              value: value,
              name: title,
            },
          ],
        },
      ],
    }
  }
  const option2 = (values: { value: number }) => {
    const { value } = values
    return {
      series: [
        {
          type: 'gauge',
          min: 0,
          max: 100,
          startAngle: 180,
          endAngle: 0,
          splitNumber: 5,
          radius: '100%',
          // axisLine: {
          //   lineStyle: {
          //     width: 10,
          //     color: [[1, '#558492']],
          //   },
          // },
          progress: {
            show: true,
            width: 10,
          },
          itemStyle: {
            color: '#558492',
          },
          pointer: {
            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
            length: '15%',
            width: 10,
            offsetCenter: [0, -45],
            itemStyle: {
              color: '#558492',
            },
          },
          axisTick: {
            length: 5,
            lineStyle: {
              color: 'auto',
              width: 1,
            },
            distance: 3,
          },
          splitLine: {
            length: 7,
            distance: 2,
            lineStyle: {
              color: 'auto',
              width: 2,
            },
          },
          axisLabel: {
            color: '#666666',
            fontSize: 8,
            distance: 15,
          },
          title: {
            offsetCenter: [0, -20],
            fontSize: 16,
          },
          detail: {
            fontSize: 20,
            offsetCenter: [0, 10],
            valueAnimation: true,
            formatter: function (num) {
              return `${Math.round(num)}%`
            },
            color: 'auto',
          },
          data: [
            {
              value: value,
              name: t('中招率'),
            },
          ],
        },
      ],
    }
  }
  const [getTaskChartDataParams, setGetTaskChartDataParams] = useState<GetTaskTrend>()
  const [deptName, setDeptName] = useState('')
  const [dey, setDay] = useState({ day: 0, len: '2', option: '1' })
  useEffect(() => {
    if (getTaskChartDataParams?.len && getTaskChartDataParams?.send_num) {
      taskChartRun().catch(_ => {})
      GetTrend().catch(_ => {})
    }
  }, [getTaskChartDataParams?.len, getTaskChartDataParams?.send_num])

  useEffect(() => {
    if (getTaskBasic?.data?.set_day) {
      setGetTaskChartDataParams({
        start_time: getTaskBasic?.data?.start_time,
        period: dey.len,
        len: dey.day || getTaskBasic?.data?.set_day,
        campaign_id: id,
        dept_name: deptName,
        send_num: taskStd.send_num,
      })
    }
  }, [getTaskBasic, taskStd])

  const chartsTab = useMemo(() => {
    if (dey?.option === '2') {
      return 'centerLeft'
    }
    if (dey?.option === '3') {
      return 'centerRight'
    }
    if (dey?.option === '4') {
      return 'right'
    }
    return 'left'
  }, [dey])
  const option12 = (values: GetOptionsProps) => {
    const {
      click,
      open,
      see,
      sub,
      time,
      type,
      barOpen,
      barSee,
      barSub,
      barThrough,
      barClick,
      through,
      trap,
      sum,
    } = values
    let arr = []
    let see1 = []
    let open1 = []
    let click1 = []
    let sub1 = []
    let trap1 = []
    let through1 = []
    let barOpen1 = []
    let barSee1 = []
    let barSub1 = []
    let barThrough1 = []
    let barClick1 = []
    if (dey.option === '2') {
      time?.forEach((item, index) => {
        if (index % 2 !== 0) {
          arr.push(item)
          open1.push(open[index])
          see1.push(see[index])
          click1.push(click[index])
          sub1.push(sub[index])
          trap1.push(trap[index])
          through1.push(through[index])
          barOpen1.push(barOpen[index - 1] + barOpen[index])
          barSee1.push(barSee[index - 1] + barSee[index])
          barSub1.push(barSub[index - 1] + barSub[index])
          barThrough1.push(barThrough[index - 1] + barThrough[index])
          barClick1.push(barClick[index - 1] + barClick[index])
        }
      })
    } else if (dey.option === '3') {
      time?.forEach((item, index) => {
        if (index % 12 === 0) {
          arr.push(item)
          open1.push(open[index - 1 + 12])
          see1.push(see[index - 1 + 12])
          click1.push(click[index - 1 + 12])
          sub1.push(sub[index - 1 + 12])
          trap1.push(trap[index - 1 + 12])
          through1.push(through[index - 1 + 12])
          let barOpen2 = barOpen[index]
          let barSee2 = barSee[index]
          let barSub2 = barSub[index]
          let barThrough2 = barThrough[index]
          let barClick2 = barClick[index]
          for (let i = 1; i < 12; i++) {
            barOpen2 += barOpen[index + i]
            barSee2 += barSee[index + i]
            barSub2 += barSub[index + i]
            barThrough2 += barThrough[index + i]
            barClick2 += barClick[index + i]
          }
          barOpen1.push(barOpen2)
          barSee1.push(barSee2)
          barSub1.push(barSub2)
          barThrough1.push(barThrough2)
          barClick1.push(barClick2)
        }
      })
    } else {
      arr = time
      open1 = open
      see1 = see
      click1 = click
      sub1 = sub
      trap1 = trap
      through1 = through
      barOpen1 = barOpen
      barSee1 = barSee
      barSub1 = barSub
      barThrough1 = barThrough
      barClick1 = barClick
    }
    return {
      tooltip: {
        axisPointer: {
          // type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
      },
      legend: {
        // data: ['查看邮件', '点击链接', '打开附件', '提交数据', '识破钓鱼', '中招趋势'],
        left: 'left',
      },
      grid: {
        left: '0%',
        right: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          data: arr,
          axisPointer: {
            type: 'shadow',
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: t('人'),
          min: 0,
          minInterval: 1,
          max: sum?.[0],
        },
        {
          type: 'value',
          name: t('中招率'),
          data: [20, 40, 60, 80, 100],
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: e => {
              if (e === 0) {
                return e
              }
              return `${e}%`
            },
          },
        },
      ],
      series: [
        {
          name: selected.includes(2) && t('查看邮件'),
          type: 'bar',
          data: selected.includes(2) && barSee1,
          itemStyle: {
            borderRadius: [10, 10, 0, 0],
            color: '#72A0FB',
          },
        },
        {
          name: selected.includes(2) && (type === '恶意附件' ? t('打开附件') : t('点击链接')),
          type: 'bar',
          data: selected.includes(2) && (type === '恶意附件' ? barOpen1 : barClick1),
          itemStyle: { borderRadius: [10, 10, 0, 0], color: '#FCC858' },
        },
        {
          name: selected.includes(2) && t('提交数据'),
          type: 'bar',
          data: selected.includes(2) && barSub1,
          itemStyle: { borderRadius: [10, 10, 0, 0], color: '#B1ACFF' },
        },
        {
          name: selected.includes(2) && t('识破钓鱼'),
          type: 'bar',
          data: selected.includes(2) && barThrough1,
          itemStyle: { borderRadius: [10, 10, 0, 0], color: '#7686A2' },
        },
        {
          name: selected.includes(1) && t('查看邮件'),
          type: 'line',
          data: selected.includes(1) && see1,
          itemStyle: {
            color: '#72A0FB',
          },
        },
        {
          name: selected.includes(1) && (type === '恶意附件' ? t('打开附件') : t('点击链接')),
          type: 'line',
          data: selected.includes(1) && (type === '恶意附件' ? open1 : click1),
          itemStyle: { color: '#FCC858' },
        },
        {
          name: selected.includes(1) && t('提交数据'),
          type: 'line',
          data: selected.includes(1) && sub1,
          itemStyle: { color: '#B1ACFF' },
        },
        {
          name: selected.includes(1) && t('识破钓鱼'),
          type: 'line',
          data: selected.includes(1) && through1,
          itemStyle: { color: '#7686A2' },
        },
        {
          name: '',
          type: 'line',
          data: sum,
          showSymbol: false,
          itemStyle: { color: '#4238C9' },
          showAllSymbol: true,
        },
        {
          name: selected.includes(3) && t('中招趋势'),
          type: 'line',
          yAxisIndex: 1,
          data: selected.includes(3) && trap1,
          itemStyle: { color: '#558492' },
        },
      ],
    }
  }
  const { selected, isSelected, toggle } = useSelections([1, 2, 3], [1, 2, 3])
  const [taskTrend, taskTrendLoading, GetTrend] = useGetTaskTrend({
    getTaskChartData: getTaskChartDataParams,
  })
  const [taskChart, taskChartLoading, taskChartRun] = useGetTaskChartData({
    getTaskChartData: getTaskChartDataParams,
  })

  const [TabTask, setTabTask] = useState<'abstract' | 'consciousness' | 'hitRate'>('abstract')
  const [getDept, deptData] = useGetDeptAware()
  const [getDeptRate, deptRateData] = useGetDeptRate()
  const chartRef = useRef<any>(null)

  // 在数据加载完成后调用 resize 以确保图表正确适应容器尺寸
  useEffect(() => {
    if (chartRef.current && taskTrend && taskChart) {
      const timer = setTimeout(() => {
        chartRef.current?.getEchartsInstance()?.resize()
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [taskTrend, taskChart, selected])

  return (
    <TaskNameFold>
      <TaskNameMain>
        {/*<img src={OverviewLine} alt="" style={{ width: '100%', height: 2, marginBottom: 20 }} />*/}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <TabAbstract tab={TabTask}>
            <div
              className="abstract"
              onClick={() => {
                setTabTask('abstract')
              }}
            >
              {t('任务摘要')}
            </div>
            <div
              className="consciousness"
              onClick={async () => {
                try {
                  setTabTask('consciousness')
                  await getDept({
                    campaign_id: id,
                    email_type: getTaskBasic?.data?.email_type === '钓鱼链接' ? '1' : '2',
                  })
                } catch (error) {}
              }}
            >
              {t('部门安全意识排名')}
            </div>
            <div
              className="hitRate"
              onClick={async () => {
                try {
                  setTabTask('hitRate')
                  await getDeptRate({
                    campaign_id: id,
                    email_type: getTaskBasic?.data?.email_type === '钓鱼链接' ? '1' : '2',
                  })
                } catch (error) {}
              }}
            >
              {t('部门中招率排名')}
            </div>
            {/* <div style={{ height: 32, lineHeight: '32px', marginLeft: 0 }} className="task-title">
              {getTaskBasic?.data?.email_type === '钓鱼链接'
                ? '响应率：点击链接人数/任务评估总人数'
                : '响应率：打开附件人数/任务评估总人数'}
            </div> */}
          </TabAbstract>
          <div>
            <Select
              style={{ width: 120 }}
              placeholder={t('请选择部门')}
              onChange={e => {
                try {
                  setTaskStdProps(origin => ({ ...origin, deptName: e }))
                  setDeptName(e)
                  setGetTaskChartDataParams(origin => ({ ...origin, dept_name: e }))
                } catch (error) {}
              }}
              allowClear
            >
              {getTaskBasic?.data.group_str?.split(',')?.map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
        </div>
        {TabTask === 'abstract' ? (
          <>
            <div className="score">
              {getTaskBasic?.data?.email_type && (
                <div className="instrument">
                  <p className="task-title">{t('评分')}</p>
                  <ReactECharts
                    style={{
                      width: 240,
                      height: 220,
                      marginBottom: -14,
                      marginLeft: 20,
                    }}
                    option={option1({
                      value: taskStd?.score || 0,
                      title: taskStd?.score
                        ? (taskStd?.score <= 100 && taskStd?.score >= 80 && t('优秀')) ||
                          (taskStd?.score < 80 && taskStd?.score >= 60 && t('良好')) ||
                          (taskStd?.score < 60 && taskStd?.score >= 40 && t('较差')) ||
                          (taskStd?.score < 40 && t('差'))
                        : t('差'),
                    })}
                  />
                </div>
              )}
              <div className="instrument">
                <p className="task-title" style={{ marginLeft: 0 }}>
                  <div>
                    <span style={{ marginRight: 6 }}>中招率</span>
                    <Tooltip
                      title={
                        getTaskBasic?.data?.email_type === '钓鱼链接'
                          ? t('中招率：点击链接人数/任务评估总人数')
                          : t('中招率：打开附件人数/任务评估总人数')
                      }
                    >
                      <IconFont type="icon-tishi" style={{ color: '#999' }} />
                    </Tooltip>
                  </div>
                </p>
                <div style={{ display: 'flex' }}>
                  <div style={{ height: 116, width: 1, background: '#DFDFDF', marginTop: 10 }} />
                  <ReactECharts
                    style={{
                      width: 240,
                      height: 220,
                      marginBottom: -14,
                      marginLeft: 15,
                    }}
                    option={option2({
                      value:
                        getTaskBasic?.data.email_type === '钓鱼链接'
                          ? Number(
                              (
                                ((taskStd.click_num || 0) / (taskStd?.send_num || 0) || 0) * 100
                              ).toFixed(0),
                            )
                          : Number(
                              (
                                ((taskStd?.attach_num || 0) / (taskStd?.send_num || 0) || 0) * 100
                              ).toFixed(0),
                            ),
                    })}
                  />
                </div>
              </div>
              <div style={{ width: 'calc(100% - 540px)' }}>
                <Tabs
                  defaultActiveKey="1"
                  tabPosition={'top'}
                  style={{ height: 220, overflow: 'hidden' }}
                  getPopupContainer={(node: any) => node?.parentNode.parentNode}
                >
                  <TabPane
                    key={1}
                    tab={
                      <div className="instrument">
                        <div className="task-title">
                          <div>
                            <IconFont
                              type="icon-yunpanlogo_huabanfuben"
                              style={{ color: '#2CAB40', marginRight: 3 }}
                            />
                            <span>{t('发送邮件')}</span>
                          </div>
                          <div className="score-text">
                            {taskStd?.send_success_num || 0} / {taskStd?.create_num || 0}
                          </div>
                        </div>
                        <div className="chart">
                          <div>
                            {(
                              ((taskStd?.send_success_num || 0) / (taskStd?.create_num || 0) || 0) *
                              100
                            ).toFixed(0)}
                            %
                          </div>
                          <img src={SendEmail} alt="" className="image" />
                        </div>
                      </div>
                    }
                  />
                  <TabPane
                    key={2}
                    tab={
                      <div className="instrument">
                        <div className="task-title">
                          <div>
                            <IconFont
                              type="icon-yulantestsvg"
                              style={{ color: '#3279FF', marginRight: 3 }}
                            />
                            <span>{t('查看邮件')}</span>
                          </div>
                          <div className="score-text">
                            {taskStd?.open_num | 0}/{taskStd?.create_num || 0}
                          </div>
                        </div>
                        <div className="chart">
                          <div>
                            {(
                              ((taskStd?.open_num || 0) / (taskStd?.create_num || 0) || 0) * 100
                            ).toFixed(0)}
                            %
                          </div>
                          <img src={LookEmail} alt="" className="image" />
                        </div>
                      </div>
                    }
                  />
                  <TabPane
                    key={3}
                    tab={
                      getTaskBasic?.data?.email_type === '钓鱼链接' && (
                        <div className="instrument">
                          <div className="task-title">
                            <div>
                              <IconFont
                                type="icon-icon-dianjifangkuang"
                                style={{ color: '#F6BE18', marginRight: 3 }}
                              />
                              <span>{t('点击链接')}</span>
                            </div>
                            <div className="score-text">
                              {taskStd?.click_num | 0}/{taskStd?.create_num || 0}
                            </div>
                          </div>
                          <div className="chart">
                            <div>
                              {(
                                ((taskStd?.click_num || 0) / (taskStd?.create_num || 0) || 0) * 100
                              ).toFixed(0)}
                              %
                            </div>
                            <img src={ClickEmail} alt="" className="image" />
                          </div>
                        </div>
                      )
                    }
                  />
                  <TabPane
                    key={4}
                    tab={
                      getTaskBasic?.data?.email_type === '恶意附件' && (
                        <div className="instrument">
                          <div className="task-title">
                            <div>
                              <IconFont
                                type="icon-icon-dianjifangkuang"
                                style={{ color: '#F6BE18', marginRight: 3 }}
                              />
                              <span>{t('打开附件')}</span>
                            </div>
                            <div className="score-text">
                              {taskStd?.attach_num || 0}/{taskStd?.create_num || 0}
                            </div>
                          </div>
                          <div className="chart">
                            <div>
                              {(
                                ((taskStd?.attach_num || 0) / (taskStd?.create_num || 0) || 0) * 100
                              ).toFixed(0)}
                              %
                            </div>
                            <img src={ClickEmail} alt="" className="image" />
                          </div>
                        </div>
                      )
                    }
                  />
                  <TabPane
                    key={5}
                    tab={
                      getTaskBasic?.data?.email_type === '钓鱼链接' && (
                        <div className="instrument">
                          <div className="task-title">
                            <div>
                              <IconFont
                                type="icon-tijiao"
                                style={{ color: '#7C74FF', marginRight: 3 }}
                              />
                              <span>{t('提交信息')}</span>
                            </div>
                            <div className="score-text">
                              {taskStd?.sub_num | 0}/{taskStd?.create_num || 0}
                            </div>
                          </div>
                          <div className="chart">
                            <div>
                              {(
                                ((taskStd?.sub_num || 0) / (taskStd?.create_num || 0) || 0) * 100
                              ).toFixed(0)}
                              %
                            </div>
                            <img src={SubmitEmail} alt="" className="image" />
                          </div>
                        </div>
                      )
                    }
                  />
                  <TabPane
                    key={6}
                    tab={
                      <div className="instrument">
                        <div className="task-title">
                          <div>
                            <IconFont
                              type="icon-yanzhengma"
                              style={{ color: '#7686a2', marginRight: 3 }}
                            />
                            <span>{t('识破钓鱼')}</span>
                          </div>
                          <div className="score-text">
                            {taskStd?.see_through_num | 0}/{taskStd?.create_num || 0}
                          </div>
                        </div>
                        <div className="chart">
                          <div>
                            {(
                              ((taskStd?.see_through_num || 0) / (taskStd?.create_num || 0) || 0) *
                              100
                            ).toFixed(0)}
                            %
                          </div>
                          <img src={SeeThrough} alt="" className="image" />
                        </div>
                      </div>
                    }
                  />
                </Tabs>
              </div>
            </div>
            <TopCard>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-end',
                  marginBottom: 24,
                }}
              >
                <BrokenLineTop active={chartsTab}>
                  <div
                    className="item left"
                    onClick={() => {
                      setDay({ day: getTaskBasic?.data?.set_day, len: '2', option: '1' })
                      if (getTaskChartDataParams.option === '1') return
                      setGetTaskChartDataParams(origin => ({
                        ...origin,
                        len: getTaskBasic?.data?.set_day,
                        option: '1',
                        period: '2',
                      }))
                    }}
                  >
                    {t('默认')}
                  </div>
                  <div
                    className="item center-left"
                    onClick={() => {
                      setDay({ day: 24, len: '1', option: '2' })
                      if (getTaskChartDataParams.len === '24') return
                      setGetTaskChartDataParams(origin => ({
                        ...origin,
                        len: '24',
                        option: '2',
                        period: '1',
                      }))
                    }}
                  >
                    {t('前24小时')}
                  </div>
                  <div
                    className="item center-right"
                    onClick={() => {
                      setDay({ day: 72, len: '1', option: '3' })
                      if (getTaskChartDataParams.len === '72') return
                      setGetTaskChartDataParams(origin => ({
                        ...origin,
                        len: '72',
                        option: '3',
                        period: '1',
                      }))
                    }}
                  >
                    {t('前3天')}
                  </div>
                  <div
                    className="item right"
                    onClick={() => {
                      setDay({ day: 7, len: '2', option: '4' })
                      if (getTaskChartDataParams.option === '4') return
                      setGetTaskChartDataParams(origin => ({
                        ...origin,
                        len: '7',
                        option: '4',
                        period: '2',
                      }))
                    }}
                  >
                    前7天
                  </div>
                </BrokenLineTop>
                <div style={{ display: 'flex' }}>
                  <Btn
                    onClick={() => {
                      toggle(1)
                      setGetTaskChartDataParams(origin => ({ ...origin }))
                    }}
                    active={isSelected(1)}
                  >
                    <IconFont type="icon-zhexiantu" />
                    <div className="btn-text">{t('累计响应')}</div>
                  </Btn>
                  <Btn
                    onClick={() => {
                      toggle(2)
                      setGetTaskChartDataParams(origin => ({ ...origin }))
                    }}
                    active={isSelected(2)}
                  >
                    <IconFont type="icon-zhuzhuangtu2" />
                    <div className="btn-text">{t('每日新增')}</div>
                  </Btn>
                  <Btn
                    onClick={() => {
                      toggle(3)
                      setGetTaskChartDataParams(origin => ({ ...origin }))
                    }}
                    active={isSelected(3)}
                  >
                    <IconFont type="icon-aims" />
                    <div className="btn-text">{t('中招趋势')}</div>
                  </Btn>
                </div>
              </div>
              <ReactECharts
                ref={chartRef}
                style={{ display: 'flex', justifyContent: 'center', height: 450 }}
                // option={getOptions({
                //   ...taskChart,
                //   type: getTaskBasic?.data?.email_type,
                //   option,
                // })}
                option={option12({
                  ...taskTrend,
                  ...taskChart,
                  type: getTaskBasic?.data?.email_type,
                  option: getTaskChartDataParams?.option,
                })}
              />
            </TopCard>
          </>
        ) : TabTask === 'hitRate' ? (
          <HitRateChart deptData={deptRateData} />
        ) : (
          <Consciousness deptData={deptData} />
        )}
      </TaskNameMain>
    </TaskNameFold>
  )
}

const TaskNameFold = styled(Card)`
  background: #fff !important;
  margin-top: 16px;
  border: none;
  .ant-collapse-header {
    width: 100%;
    padding-right: 20px !important;
    padding-bottom: 0px !important;
  }
  .ant-collapse-header-text {
    width: 100%;
  }
  .ant-collapse-content-box {
    padding-top: 0 !important;
  }
`
const TaskNameMain = styled.div`
  .score {
    width: 100%;
    display: flex;
    background: #f8f9fb;
    border-radius: 9px;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #333;
    text-shadow: unset;
  }
  .ant-tabs-ink-bar {
    background: transparent;
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0;
    padding: 0;
  }
  .instrument {
    flex: 1;
    padding: 17px 12px 17px 0;
    height: 220px;
    width: 332px;
    min-height: 140px;
    overflow: hidden;
  }
  .task-title {
    font-size: 14px;
    color: #666;
    display: flex;
    justify-content: space-between;
    margin-left: 16px;
    padding-left: 10px;
    padding-right: 10px;
    font-weight: 600;
  }
  .chart {
    height: 116px;
    display: flex;
    align-items: flex-end;
    border-left: 1px solid #dfdfdf;
    padding: 0 0 0 25px;
    font-size: 24px;
    font-weight: 600;
    margin-top: 10px;
    justify-content: space-between;
  }
  .score-text {
    font-size: 16px;
  }
  .image {
    width: 70%;
    margin-bottom: -16px;
  }
`
const TopCard = styled(Card)`
  border: none;
  margin-bottom: 20px;
  border-radius: 8px;
  /* box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06); */
  .ant-card-head-title {
    padding-top: 0;
    font-weight: 500;
  }
  .ant-btn {
  }
`
interface BtnProps {
  active: boolean
}
const Btn = styled.span<BtnProps>`
  display: inline-block;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 68px;
  height: 46px;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #c6caee;
  &:nth-child(1) {
    border-radius: 4px 0 0 4px;
    border-right: 0;
  }
  &:nth-child(3) {
    border-radius: 0 4px 4px 0;
    border-left: 0;
  }
  background: ${props => (props.active ? '#E2E4F6' : '#FFFFFF')};
  color: ${props => (props.active ? '#4238C9' : '#333')};
  .btn-text {
    width: 100%;
    text-align: center;
    font-size: 12px;
  }
`
interface BrokenLineTopProps {
  active: 'left' | 'center' | 'right'
}
const BrokenLineTop = styled.div<BrokenLineTopProps>`
  display: flex;
  cursor: pointer;
  .item {
    width: 94px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }
  .left {
    color: ${props => (props.active === 'left' ? '#4238C9' : '#333333')};
    background-color: ${props => (props.active === 'left' ? '#E2E4F6' : '#EFEFEF')};
    border-radius: 8px 0px 0px 8px;
  }
  .center-left {
    color: ${props => (props.active === 'center' ? '#4238C9' : '#333333')};
    background-color: ${props => (props.active === 'centerLeft' ? '#E2E4F6' : '#EFEFEF')};
    margin: 0 6px;
  }
  .center-right {
    color: ${props => (props.active === 'center' ? '#4238C9' : '#333333')};
    background-color: ${props => (props.active === 'centerRight' ? '#E2E4F6' : '#EFEFEF')};
    margin-right: 6px;
  }
  .right {
    color: ${props => (props.active === 'right' ? '#4238C9' : '#333333')};
    background-color: ${props => (props.active === 'right' ? '#E2E4F6' : '#EFEFEF')};
    border-radius: 0px 8px 8px 0px;
  }
`
interface TabAbstractProps {
  tab: 'consciousness' | 'abstract'
}
const TabAbstract = styled.div<TabAbstractProps>`
  display: flex;
  .consciousness,
  .hitRate,
  .abstract {
    width: 160px;
    height: 32px;
    font-weight: 500;
    color: #4238c9;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    cursor: pointer;
    transition: all 0.3s;
  }
  .consciousness {
    margin-left: 4px;
    background: ${props => (props.tab === 'consciousness' ? '#E2E4F6' : '#f1f3f8')};
  }
  .hitRate {
    border-radius: 0px 8px 8px 0px;
    margin-left: 4px;
    background: ${props => (props.tab === 'hitRate' ? '#E2E4F6' : '#f1f3f8')};
  }
  .abstract {
    border-radius: 8px 0px 0px 8px;
    background: ${props => (props.tab === 'abstract' ? '#E2E4F6' : '#f1f3f8')};
  }
`
